import { observer } from "mobx-react-lite";
import {
  MdsItemListSkeletonRowData,
  MdsItemListRowType,
  MdsItemListAsyncSessionRowData,
} from "@/design-system/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { MdsItemListSkeletonRow } from "@/design-system/components/item-list/rows/MdsItemListSkeletonRow";
import { MdsItemListItemRow } from "@/design-system/components/item-list/rows/MdsItemListItemRow";

export interface MdsItemListAsyncSessionRowProps {
  data: MdsItemListAsyncSessionRowData;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListAsyncSessionRow: FC<MdsItemListAsyncSessionRowProps> = observer(
  ({ data }) => {
    const { store } = useAppStore();
    const session = store.sessions.get(data.payload.sessionId);

    const skeletonRowData: MdsItemListSkeletonRowData = {
      key: data.key,
      type: MdsItemListRowType.Skeleton,
      size: data.size,
      payload: {},
    };

    if (!session) return <MdsItemListSkeletonRow data={skeletonRowData} />;

    const itemRowData =
      typeof data.payload.itemRow === "function"
        ? data.payload.itemRow(session)
        : data.payload.itemRow;

    return <MdsItemListItemRow data={itemRowData} />;
  }
);
